import { createAsyncThunk } from "@reduxjs/toolkit";
import { areaData } from "../../Types/Types";
import axios from "axios";

export const getAreas = createAsyncThunk(
  "areas/getAreas",
  async (data, thunkApi) => {
    try {
      const response = await axios.get<areaData[]>(
        "https://api.npoint.io/1db60ff53bf002f089b2"
      );

      return response.data;
    } catch (error: any) {
      const message = error.message;
      return thunkApi.rejectWithValue(message);
    }
  }
);
